import React from 'react';
import { is8DataApp } from '../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Status from '../../BuildingBlocks/Misc/Status';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme: any) => ({
  table: {
    '& .MuiTableCell-root': {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  },
  header: { fontWeight: 'bold' },
  tableBody: {
    height: theme.spacing(7),
  },
  content: {
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },
}));

export default function StoreConnections({ companyData }) {
  const classes = useStyles();
  const headers = ['Store Name', 'Store URL', 'Year Established', 'Status'];
  const { name, yearEstablished, storeUrl } = companyData ?? {};
  const is8Data = is8DataApp();
  return (
    <div className={classes.content}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header} className={classes.header}>
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {companyData && (
            <TableRow className={classes.tableBody}>
              <TableCell>{name}</TableCell>
              <TableCell>
                <Link href={storeUrl}>{storeUrl}</Link>
              </TableCell>
              <TableCell>{yearEstablished}</TableCell>
              <TableCell>
                {!!storeUrl ? (
                  <Status is8Data={is8Data} status="connected" />
                ) : (
                  <Status status="notConnected" label="Not Connected" />
                )}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
